<template>
    <div v-if="searchRequest" class="text-caption text--secondary">
        <span v-if="roomsCount">{{ roomsCount }} {{ $t('room', roomsCount) }},</span>
        {{ touristsTotal }} {{ $t('guest', touristsTotal) }}, {{ nights }} {{ $t('night', nights) }}
        <div v-if="loyaltyPoints">{{ `${$t('loyalty')}: ${loyaltyPoints}` }}</div>
    </div>
</template>

<script lang="ts">
    import {Component, Prop, Vue} from 'vue-facing-decorator'

    @Component
    export class HotelPriceNote extends Vue {
        @Prop({required: true}) searchRequest
        @Prop({default: 0}) roomsCount
        @Prop({default: 0}) rph
        @Prop() loyaltyPoints

        get nights() {
            if (!this.searchRequest) return 0
            return this.$dateFns.differenceInDays(
                this.$dateFns.parseISO(this.searchRequest.endDate),
                this.$dateFns.parseISO(this.searchRequest.startDate)
            )
        }

        get touristsTotal() {
            if (!this.searchRequest) return 0
            if (this.rph) {
                const tourists = hotelsRuntimeStore.searchRequestTouristsJSON(this.searchRequest)[this.rph - 1]
                return tourists.adults + tourists.childrenAges.length
            }
            return hotelsRuntimeStore.searchRequestTouristsTotal(this.searchRequest)
        }
    }

    export default HotelPriceNote
</script>

<style scoped>
    .text-caption {
        line-height: 1rem;
    }
</style>
